/* card-frames.js - adds seasonal frames, animated borders and corner decorations to product cards */
(function () {
  var CARD = '.product-card, .pcs-card';
  var ART = {
    palm: `<g fill='#2f9e5b'><path d='M0 0C16 1 30 9 36 26C24 17 11 12 0 12z'/><path d='M0 0C10 8 14 22 11 38C6 25 3 14 0 14z'/></g><path d='M0 0C22-3 38 3 47 15C32 9 16 7 0 8z' fill='#43b86f'/><path d='M0 0L22 22' stroke='#1f7a45' stroke-width='1.4' fill='none'/><g transform='translate(27 3) scale(.62)'><path d='M12 3l2.4 6.3L21 10l-5 4.4 1.6 6.6L12 17.4 6.4 21 8 14.4 3 10l6.6-.7z' fill='#f6c96b' stroke='#f6c96b' stroke-width='2.4' stroke-linejoin='round'/></g>`,
    wave: `<path d='M0 48V28c6-5 11 4 17 0s10 3 15-1c4-3 9 2 16-2V48z' fill='#3aaee8'/><path d='M0 48V37c6-4 11 3 17-1s10 2 15-1 9 1 16-2V48z' fill='#1d8fd0'/><circle cx='9' cy='24' r='2' fill='#fff' opacity='.7'/><circle cx='24' cy='23' r='1.4' fill='#fff' opacity='.7'/>`,
    surf: `<g transform='rotate(14 34 26)'><ellipse cx='34' cy='28' rx='7.5' ry='19' fill='#ffd54a'/><path d='M34 9V47' stroke='#fff' stroke-width='2'/><path d='M30 26h8M30 32h8' stroke='#f59f00' stroke-width='1.4'/></g>`,
    snowflake: `<g stroke='#7fc1ee' stroke-width='3' stroke-linecap='round' fill='none'><path d='M22 4V40M6.4 13l31.2 18M6.4 31l31.2-18'/><path d='M17 8l5 4 5-4M17 36l5-4 5 4' stroke-width='2'/></g>`,
    mound: `<path d='M0 48V36c8-8 18-8 26 0 6-5 14-4 22 2V48z' fill='#fff' stroke='#bcdff5' stroke-width='1.5'/><circle cx='14' cy='34' r='1.6' fill='#bcdff5'/><circle cx='34' cy='36' r='1.4' fill='#bcdff5'/>`,
    maple: `<g transform='rotate(-20 24 24)'><path d='M24 4c6 6 12 8 16 8-2 6-2 10 2 14-6 0-9 2-10 8-4-3-6-3-8 0 0-6-3-8-8-8 3-4 2-8 0-14 5 0 11-2 16-8z' fill='#e8590c'/><path d='M24 12V44' stroke='#a63f06' stroke-width='1.6'/></g>`,
    pumpkin: `<ellipse cx='24' cy='31' rx='16' ry='13' fill='#f76707'/><path d='M24 18v-6' stroke='#2b8a3e' stroke-width='3' stroke-linecap='round'/><path d='M16 21c-4 6-4 16 0 21M32 21c4 6 4 16 0 21M24 18V44' stroke='#c2410c' stroke-width='1.6' fill='none'/>`,
    flower: `<g fill='#ff8fab'><circle cx='24' cy='11' r='7'/><circle cx='36' cy='20' r='7'/><circle cx='31' cy='34' r='7'/><circle cx='17' cy='34' r='7'/><circle cx='12' cy='20' r='7'/></g><circle cx='24' cy='24' r='6' fill='#ffd166'/>`,
    sprig: `<path d='M0 48C2 30 14 20 30 18 28 34 18 46 0 48z' fill='#6bbf59'/><path d='M3 45C10 34 18 26 28 20' stroke='#3f8f3a' stroke-width='1.4' fill='none'/>`,
    holly: `<path d='M2 6c8 0 14 4 16 12-8 0-14-4-16-12zM20 22c-1 8-6 14-14 16 0-8 6-14 14-16z' fill='#2b8a3e'/><circle cx='20' cy='14' r='4.5' fill='#e03131'/><circle cx='27' cy='20' r='4.5' fill='#e03131'/><circle cx='15' cy='22' r='4.5' fill='#c92a2a'/>`,
    gift: `<rect x='6' y='22' width='36' height='24' rx='3' fill='#e03131'/><rect x='21' y='22' width='6' height='24' fill='#ffd43b'/><rect x='4' y='16' width='40' height='8' rx='2' fill='#c92a2a'/><path d='M24 16c-6-8-14-4-10 0M24 16c6-8 14-4 10 0' stroke='#ffd43b' stroke-width='3' fill='none'/>`,
    bauble: `<circle cx='24' cy='30' r='15' fill='#e03131'/><rect x='20' y='10' width='8' height='6' rx='1' fill='#ffd43b'/><path d='M14 26c4-6 14-8 20-4' stroke='#fff' stroke-width='2' fill='none' opacity='.6'/>`,
    bat: `<path d='M24 18c3-6 10-8 18-4-3 2-3 6-1 9-4-2-7-1-9 3-2-3-5-3-8 0-2-4-5-5-9-3 2-3 2-7-1-9 8-4 15-2 18 4z' fill='#2b2b3a'/><circle cx='20' cy='20' r='1.2' fill='#ffd43b'/><circle cx='28' cy='20' r='1.2' fill='#ffd43b'/>`,
    ghost: `<path d='M8 46V22a16 16 0 0 1 32 0v24l-5.3-4-5.4 4-5.3-4-5.3 4-5.4-4z' fill='#fff' stroke='#cfd4dc' stroke-width='1.5'/><circle cx='19' cy='24' r='2.4' fill='#2b2b3a'/><circle cx='29' cy='24' r='2.4' fill='#2b2b3a'/>`,
    heart: `<path d='M24 42S6 31 6 18a9 9 0 0 1 18-4 9 9 0 0 1 18 4c0 13-18 24-18 24z' fill='#f03e68'/><path d='M14 16c0-3 3-5 6-4' stroke='#fff' stroke-width='2' fill='none' opacity='.6' stroke-linecap='round'/>`,
    heart2: `<path d='M16 40S4 32 4 23a6 6 0 0 1 12-3 6 6 0 0 1 12 3c0 9-12 17-12 17z' fill='#ff6b8b'/><path d='M34 30S28 26 28 21a3.5 3.5 0 0 1 6-2 3.5 3.5 0 0 1 6 2c0 5-6 9-6 9z' fill='#f03e68'/>`,
    crescent: `<path d='M30 6a18 18 0 1 0 0 36 14 14 0 1 1 0-36z' fill='#f2c94c'/><path d='M38 14l1.8 4.2 4.4.4-3.3 2.9 1 4.4-3.9-2.3-3.9 2.3 1-4.4-3.3-2.9 4.4-.4z' fill='#f2c94c'/>`,
    lantern: `<path d='M24 2v8' stroke='#d4a017' stroke-width='2'/><rect x='14' y='10' width='20' height='5' rx='2' fill='#d4a017'/><path d='M14 15h20l4 18H10z' fill='#f2c94c'/><rect x='12' y='33' width='24' height='5' rx='2' fill='#d4a017'/><path d='M20 15v18M28 15v18' stroke='#b8860b' stroke-width='1.2'/>`,
    bolt: `<path d='M28 3L10 28h12l-4 17 20-27H26z' fill='#ffd43b' stroke='#111' stroke-width='2' stroke-linejoin='round'/>`,
    tag: `<path d='M6 26l18-18h18v18L24 44z' fill='#ffd43b' stroke='#111' stroke-width='2' stroke-linejoin='round'/><circle cx='34' cy='16' r='3' fill='#111'/>`
  };
  var FRAMES = {
    summer: { c1: '#1d9bd8', c2: '#ffd54a', type: 'solid', art: { tl: 'palm', tr: 'm:tl', bl: 'wave', br: 'surf' } },
    winter: { c1: '#6db6e8', c2: '#ffffff', type: 'double', art: { tl: 'snowflake', tr: 'm:tl', bl: 'mound', br: 'm:bl' } },
    autumn: { c1: '#d9480f', c2: '#ffd8a8', type: 'double', art: { tl: 'maple', tr: 'm:tl', bl: 'pumpkin', br: 'maple' } },
    spring: { c1: '#f783ac', c2: '#ffffff', type: 'double', art: { tl: 'flower', tr: 'sprig', bl: 'sprig', br: 'flower' } },
    christmas: { c1: '#d6282c', c2: '#ffffff', type: 'stripe', art: { tl: 'holly', tr: 'm:tl', bl: 'gift', br: 'bauble' } },
    halloween: { c1: '#ff7a1a', c2: '#2b2b3a', type: 'double', art: { tl: 'bat', tr: 'm:tl', bl: 'ghost', br: 'pumpkin' } },
    valentine: { c1: '#f03e68', c2: '#ffe3ea', type: 'double', art: { tl: 'heart', tr: 'm:tl', bl: 'heart2', br: 'heart' } },
    eid: { c1: '#0f766e', c2: '#f2c94c', type: 'double', art: { tl: 'crescent', tr: 'lantern', bl: 'm:tr', br: 'm:tl' } },
    blackfriday: { c1: '#111111', c2: '#ffd43b', type: 'stripe', art: { tl: 'bolt', tr: 'm:tl', bl: 'tag', br: 'm:bl' } },
    gold: { c1: '#d4a017', c2: '#fff1b8', type: 'double', art: {} },
    neon: { c1: '#22d3ee', c2: '#a855f7', type: 'solid', glow: true, art: {} },
    clean: { c1: '#d1d5db', c2: '#ffffff', type: 'solid', art: {} }
  };
  var ANIMS = ['rotate', 'march', 'shimmer', 'pulse'];
  var configs = [];
  var timer = null;
  function split(s) { return (s || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean); }
  function lower(a) { return a.map(function (x) { return x.toLowerCase(); }); }
  function num(el, k, d) { var v = parseFloat(el.getAttribute('data-' + k)); return isNaN(v) ? d : v; }
  function isDate(s) { return s.length === 10 && s.charAt(4) === '-' && s.charAt(7) === '-'; }
  function today() {
    var d = new Date();
    function p(n) { return (n < 10 ? '0' : '') + n; }
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
  }
  function eligible(el, pageType) {
    var s = el.getAttribute('data-start') || '';
    var e = el.getAttribute('data-end') || '';
    var t = today();
    if (isDate(s) && t < s) return false;
    if (isDate(e) && t > e) return false;
    var path = (window.location.pathname || '/').toLowerCase();
    var ex = lower(split(el.getAttribute('data-exclude')));
    if (ex.some(function (x) { return path.indexOf(x) > -1; })) return false;
    if (el.getAttribute('data-all') === 'true') return true;
    var types = (el.getAttribute('data-types') || '').split(',');
    if (types.indexOf(pageType) > -1) return true;
    var urls = lower(split(el.getAttribute('data-urls')));
    return urls.some(function (x) { return x === '/' ? path === '/' : path.indexOf(x) > -1; });
  }
  function handleOf(card) {
    if (card.__h !== undefined) return card.__h;
    var a = card.querySelector('a[href*=products]');
    var h = '';
    if (a) {
      var part = (a.getAttribute('href') || '').split('/products/')[1] || '';
      h = part.split('?')[0].split('#')[0].split('/')[0].toLowerCase();
      try { h = decodeURIComponent(h); } catch (e) {}
    }
    card.__h = h;
    return h;
  }
  function sectionInfo(card) {
    var s = card.closest ? card.closest('.shopify-section') : null;
    var id = s ? (s.id || '').toLowerCase() : '';
    var hd = s ? s.querySelector('h1,h2,h3') : null;
    return { id: id, heading: hd ? (hd.textContent || '').trim().toLowerCase() : '' };
  }
  function isSale(card) { return !!card.querySelector('.product-card__badge--sale, .pcs-badge'); }
  function passes(cfg, card) {
    if (cfg.onlySale && !isSale(card)) return false;
    if (cfg.filterTargets && cfg.targets.indexOf(handleOf(card)) < 0) return false;
    if (cfg.sections.length) {
      var info = sectionInfo(card);
      var ok = cfg.sections.some(function (t) { return info.id.indexOf(t) > -1 || info.heading.indexOf(t) > -1; });
      if (!ok) return false;
    }
    return true;
  }
  function build(cfg) {
    var f = FRAMES[cfg.frame] || FRAMES.summer;
    var anim = ANIMS.indexOf(cfg.banim) > -1 ? cfg.banim : '';
    var gradientAnim = anim === 'rotate' || anim === 'march' || anim === 'shimmer';
    var layer = document.createElement('span');
    layer.className = 'cf-layer' + (cfg.animate ? ' cf-anim' : '') + ((cfg.glow || f.glow) ? ' cf-glow' : '') + (anim ? ' cf-banim-' + anim : '');
    layer.setAttribute('aria-hidden', 'true');
    layer.style.cssText = '--cf-c1:' + (cfg.c1 || f.c1) + ';--cf-c2:' + (cfg.c2 || f.c2) + ';--cf-w:' + cfg.thick + 'px;--cf-r:' + cfg.radius + 'px;--cf-size:' + cfg.size + 'px;--cf-off:' + cfg.off + 'px;--cf-op:' + (cfg.opacity / 100) + ';--cf-spd:' + cfg.bspeed + 's';
    if (cfg.thick > 0) {
      var b = document.createElement('span');
      b.className = 'cf-border cf-border--' + (gradientAnim ? 'anim' : f.type);
      layer.appendChild(b);
    }
    ['tl', 'tr', 'bl', 'br'].forEach(function (k) {
      if (!cfg.show[k]) return;
      var name = f.art[k];
      var flip = false;
      if (name && name.indexOf('m:') === 0) { name = f.art[name.slice(2)]; flip = true; }
      if (!name || !ART[name]) return;
      var d = document.createElement('span');
      d.className = 'cf-d cf-' + k + (flip ? ' cf-flip' : '');
      d.innerHTML = `<svg viewBox='0 0 48 48' aria-hidden='true'>${ART[name]}</svg>`;
      layer.appendChild(d);
    });
    return layer;
  }
  function clear() {
    [].slice.call(document.querySelectorAll('.cf-layer')).forEach(function (l) { if (l.parentNode) l.parentNode.removeChild(l); });
    [].slice.call(document.querySelectorAll('.cf-host')).forEach(function (h) { h.classList.remove('cf-host'); });
    [].slice.call(document.querySelectorAll(CARD)).forEach(function (c) { c.__cf = false; });
  }
  function applyAll() {
    if (!configs.length) return;
    [].slice.call(document.querySelectorAll(CARD)).forEach(function (card) {
      if (card.__cf) return;
      var host = card.querySelector('.product-card__media, .pcs-card__media') || card;
      for (var i = 0; i < configs.length; i++) {
        var cfg = configs[i];
        if (!passes(cfg, card)) continue;
        if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
        host.classList.add('cf-host');
        host.appendChild(build(cfg));
        card.__cf = true;
        break;
      }
    });
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(applyAll, 80);
  }
  function run() {
    clear();
    configs = [];
    var root = document.getElementById('card-frames');
    if (!root) return;
    var pageType = root.getAttribute('data-page-type') || '';
    [].slice.call(root.querySelectorAll('[data-cf]')).forEach(function (el) {
      if (!eligible(el, pageType)) return;
      configs.push({
        frame: el.getAttribute('data-frame') || 'summer',
        onlySale: el.getAttribute('data-only-sale') === 'true',
        filterTargets: el.getAttribute('data-filter-targets') === 'true',
        targets: lower(split(el.getAttribute('data-targets'))),
        sections: lower(split(el.getAttribute('data-sections'))),
        thick: num(el, 'thick', 4),
        radius: num(el, 'radius', 12),
        size: num(el, 'size', 44),
        off: num(el, 'off', -6),
        opacity: num(el, 'opacity', 100),
        c1: el.getAttribute('data-c1') || '',
        c2: el.getAttribute('data-c2') || '',
        glow: el.getAttribute('data-glow') === 'true',
        animate: el.getAttribute('data-animate') === 'true',
        banim: el.getAttribute('data-banim') || 'none',
        bspeed: num(el, 'bspeed', 4),
        show: {
          tl: el.getAttribute('data-tl') !== 'false',
          tr: el.getAttribute('data-tr') !== 'false',
          bl: el.getAttribute('data-bl') !== 'false',
          br: el.getAttribute('data-br') !== 'false'
        }
      });
    });
    applyAll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && ((n.matches && n.matches(CARD)) || (n.querySelector && n.querySelector(CARD)))) { schedule(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
